


export default class Palette{
    static light = {
        'primary' : '#FFD600',
        'secondary' : '#212121',
        'black' : '#181818',
        'grey' : '#8A8A8A',
        'white' : '#FFFFFF',
        'tertiary' : '#FFFADE',
    };
}